import React, { useEffect, useState, useRef, Suspense, lazy, createElement } from 'react';
import { Check, Music, Clock, Shield, Star, ChevronLeft, ChevronRight, Download, Lock, Infinity, Zap, Eye } from 'lucide-react';
import { TestimonialCard } from '../components/TestimonialCard';
(function preconnectEarly() {
  if (typeof document === 'undefined') return;
  const hosts = ['https://cdn.magicpatterns.com', 'https://upload.wikimedia.org', 'https://connect.facebook.net'];
  hosts.forEach(href => {
    if (!document.querySelector(`link[href="${href}"]`)) {
      const link = document.createElement('link');
      link.rel = 'preconnect';
      link.href = href;
      link.crossOrigin = 'anonymous';
      document.head.appendChild(link);
      const dns = document.createElement('link');
      dns.rel = 'dns-prefetch';
      dns.href = href;
      document.head.appendChild(dns);
    }
  });
})();
const PurchaseNotification = lazy(() => import('../components/PurchaseNotification').then(m => ({
  default: m.PurchaseNotification
})));
const materialPreviewImages = [{
  src: 'https://cdn.magicpatterns.com/uploads/6h1kqxdvUrKVQp99gsDVfK/Captura_de_pantalla_2026-02-02_a_la(s)_1.33.28_p._m..png',
  title: 'Worksheet: Pronouns'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/s2FmJ5NGX2jkrYL11a95o3/Captura_de_pantalla_2026-02-02_a_la(s)_1.33.38_p._m..png',
  title: 'Ejercicios: Pronouns'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/x1hxu3VxNHkN6fuUb1RzGz/Captura_de_pantalla_2026-02-02_a_la(s)_1.33.46_p._m..png',
  title: 'Portada de Unidad'
}];
const trackAddToCart = () => {
  if (typeof (window as any).fbq === 'function') {
    ;
    (window as any).fbq('track', 'AddToCart');
  }
};
export function LandingPage() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 0,
    minutes: 14,
    seconds: 57
  });
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isCarouselActive, setIsCarouselActive] = useState(false);
  const [viewers] = useState(Math.floor(Math.random() * 18) + 23);
  const carouselRef = useRef<HTMLDivElement>(null);
  const nextSlide = () => setCurrentSlide(prev => (prev + 1) % materialPreviewImages.length);
  const prevSlide = () => setCurrentSlide(prev => (prev - 1 + materialPreviewImages.length) % materialPreviewImages.length);
  useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      if (entries[0].isIntersecting) setIsCarouselActive(true);
    }, {
      rootMargin: '200px'
    });
    if (carouselRef.current) observer.observe(carouselRef.current);
    return () => observer.disconnect();
  }, []);
  useEffect(() => {
    if (!isCarouselActive) return;
    const autoPlay = setInterval(nextSlide, 5000);
    return () => clearInterval(autoPlay);
  }, [isCarouselActive]);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) return {
          ...prev,
          seconds: prev.seconds - 1
        };
        if (prev.minutes > 0) return {
          hours: prev.hours,
          minutes: prev.minutes - 1,
          seconds: 59
        };
        if (prev.hours > 0) return {
          hours: prev.hours - 1,
          minutes: 59,
          seconds: 59
        };
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  useEffect(() => {
    const loadMetaPixel = () => {
      const script = document.createElement('script');
      script.innerHTML = `
        !function(f,b,e,v,n,t,s)
        {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
        n.callMethod.apply(n,arguments):n.queue.push(arguments)};
        if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
        n.queue=[];t=b.createElement(e);t.async=!0;
        t.src=v;s=b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t,s)}(window, document,'script',
        'https://connect.facebook.net/en_US/fbevents.js');
        fbq('init', '1181648490064668');
        fbq('track', 'PageView');
      `;
      document.head.appendChild(script);
    };
    if ('requestIdleCallback' in window) {
      ;
      (window as any).requestIdleCallback(loadMetaPixel, {
        timeout: 3000
      });
    } else {
      setTimeout(loadMetaPixel, 2000);
    }
  }, []);
  useEffect(() => {
    const link = document.createElement('link');
    link.rel = 'preconnect';
    link.href = 'https://cdn.magicpatterns.com';
    document.head.appendChild(link);
  }, []);
  // Preload hero image for LCP
  useEffect(() => {
    const link = document.createElement('link');
    link.rel = 'preload';
    link.as = 'image';
    link.href = 'https://cdn.magicpatterns.com/uploads/sVvQehxuH5fokS3V54icV3/PROYECTOS_Anuales_(1080_x_900_px).png';
    document.head.appendChild(link);
  }, []);
  return <div className="min-h-screen bg-white font-sans text-gray-900" data-id="element-26">
      <Suspense fallback={null} data-id="element-27">
        <PurchaseNotification data-id="element-28" />
      </Suspense>

      {/* Announcement Bar */}
      <div className="bg-green-700 text-white text-center py-1.5 px-4 text-xs font-semibold sticky top-0 z-50" data-id="element-29">
        <div className="flex items-center justify-center gap-2 flex-wrap" data-id="element-30">
          <Clock className="w-3 h-3 flex-shrink-0" data-id="element-31" />
          <span data-id="element-32">🔥 Oferta por tiempo limitado — termina en:</span>
          <span className="font-mono font-black bg-green-900 px-1.5 py-0.5 rounded text-xs" data-id="element-33">
            {String(timeLeft.hours).padStart(2, '0')}:
            {String(timeLeft.minutes).padStart(2, '0')}:
            {String(timeLeft.seconds).padStart(2, '0')}
          </span>
        </div>
      </div>

      {/* Hero Section */}
      <header className="bg-white pt-8 pb-10 px-4 md:px-8 border-b border-gray-100" data-id="element-34">
        <div className="max-w-4xl mx-auto text-center" data-id="element-35">
          {/* Stars */}
          <div className="flex items-center justify-center gap-1 mb-3" data-id="element-36">
            {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-37" />)}
            <span className="text-sm text-gray-500 ml-2 font-medium" data-id="element-38">
              4.9 · +1,200 docentes
            </span>
          </div>

          <div className="inline-flex items-center gap-2 bg-green-50 text-green-700 border border-green-200 px-3 py-1 rounded-full text-xs font-semibold mb-3" data-id="element-39">
            <Music className="w-3.5 h-3.5" data-id="element-40" />
            PARA DOCENTES DE MÚSICA
          </div>

          <h1 className="text-3xl md:text-4xl font-black text-gray-900 mb-1 leading-tight" data-id="element-41">
            ORGANIZÁ TODO
            <br data-id="element-42" />
            TU AÑO DE MÚSICA
          </h1>
          <h2 className="text-2xl md:text-3xl font-black text-green-600 mb-5 leading-tight" data-id="element-43">
            SIN ESTRÉS
          </h2>

          <div className="relative mx-auto max-w-[220px] mb-5" data-id="element-44">
            <img src="https://cdn.magicpatterns.com/uploads/sVvQehxuH5fokS3V54icV3/PROYECTOS_Anuales_(1080_x_900_px).png" alt="Megapack Música Lista" className="w-full drop-shadow-xl" fetchPriority="high" width="1080" height="900" decoding="async" data-id="element-45" />
            <div className="absolute -top-3 -right-3 bg-red-500 text-white font-black text-sm px-3 py-1.5 rounded-full shadow-lg rotate-6" data-id="element-46">
              −74%
            </div>
          </div>

          <p className="text-gray-600 text-base mb-1" data-id="element-47">
            Sistema completo de clases, actividades y proyectos musicales listos
            para usar.
          </p>
          <p className="text-gray-800 font-semibold text-sm mb-4" data-id="element-48">
            Todo tu año de Música resuelto (Inicial · Primaria · Secundaria)
          </p>

          {/* Viewers */}
          <div className="flex items-center justify-center gap-2 text-sm text-orange-600 font-medium mb-4" data-id="element-49">
            <Eye className="w-4 h-4" data-id="element-50" />
            <span data-id="element-51">{viewers} personas están viendo esto ahora</span>
          </div>

          <a href="#checkout" className="inline-block bg-green-600 hover:bg-green-700 active:bg-green-800 text-white font-black text-lg px-8 py-4 rounded-xl shadow-lg hover:shadow-xl transition-all duration-200 mb-4 w-full max-w-sm" data-id="element-52">
            🛒 QUIERO ACCESO INMEDIATO
          </a>

          <div className="flex flex-wrap justify-center gap-4 text-xs text-gray-500" data-id="element-53">
            <span className="flex items-center gap-1.5" data-id="element-54">
              <Lock className="w-3 h-3 text-green-600" data-id="element-55" /> Pago seguro
            </span>
            <span className="flex items-center gap-1.5" data-id="element-56">
              <Download className="w-3 h-3 text-green-600" data-id="element-57" /> Descarga inmediata
            </span>
            <span className="flex items-center gap-1.5" data-id="element-58">
              <Shield className="w-3 h-3 text-green-600" data-id="element-59" /> Garantía 7 días
            </span>
            <span className="flex items-center gap-1.5" data-id="element-60">
              <Infinity className="w-3 h-3 text-green-600" data-id="element-61" /> Acceso de por vida
            </span>
          </div>
        </div>
      </header>

      {/* Problem Section */}
      <section className="py-14 px-4 bg-gray-50" data-id="element-62">
        <div className="max-w-3xl mx-auto" data-id="element-63">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-10" data-id="element-64">
            Si enseñás Música, esto te va a sonar muy familiar...
          </h2>

          <div className="bg-white p-8 rounded-2xl shadow-sm border border-gray-200 mb-8" data-id="element-65">
            <p className="text-lg text-gray-700 mb-4" data-id="element-66">
              Llegás cansado/a. Sabés que tenés que planificar. Abrís la
              computadora.
            </p>
            <p className="text-xl font-bold text-gray-900 mb-4" data-id="element-67">
              Y una vez más empezás desde cero.
            </p>
            <p className="text-gray-500 italic" data-id="element-68">
              Buscando partituras. Buscando canciones. Buscando ideas. Buscando
              actividades que "funcionen".
            </p>
          </div>

          <div className="text-center" data-id="element-69">
            <p className="text-xl text-gray-800 mb-6" data-id="element-70">
              El tiempo pasa rápido. El cansancio aumenta. Y tu cabeza no se
              apaga.
            </p>
            <h3 className="text-2xl font-bold text-gray-900 mb-5" data-id="element-71">
              El problema real — Todo al mismo tiempo:
            </h3>
            <div className="flex flex-wrap justify-center gap-2.5 mb-8" data-id="element-72">
              {['Planificar clases', 'Pensar actividades', 'Preparar evaluaciones', 'Organizar actos', 'Armar proyectos', 'Motivar estudiantes', 'Registrar avances'].map(item => <span key={item} className="bg-white border border-gray-200 text-gray-700 px-4 py-2 rounded-full text-sm font-medium shadow-sm" data-id="element-73">
                  {item}
                </span>)}
            </div>
            <div className="bg-green-50 p-6 rounded-2xl inline-block border border-green-200" data-id="element-74">
              <p className="text-lg font-bold text-green-900" data-id="element-75">
                👉 Es porque estás intentando sostener todo el año sin un
                sistema que te sostenga a vos.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Solution Section */}
      <section className="py-14 px-4 bg-white" data-id="element-76">
        <div className="max-w-4xl mx-auto text-center" data-id="element-77">
          <span className="inline-block bg-green-100 text-green-700 px-4 py-1.5 rounded-full text-sm font-bold mb-5 uppercase tracking-wide" data-id="element-78">
            La Solución Definitiva
          </span>
          <h2 className="text-4xl md:text-5xl font-black text-gray-900 mb-5" data-id="element-79">
            🎼 MEGAPACK MÚSICA LISTA™
          </h2>
          <p className="text-xl text-gray-500 mb-10 max-w-3xl mx-auto" data-id="element-80">
            Un sistema anual completo de Música, basado en actividades reales,
            probadas en aula y pensadas para la escuela real.
          </p>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 max-w-2xl mx-auto" data-id="element-81">
            {['Todo listo', 'Todo probado', 'Todo organizado', 'Todo usable'].map(item => <div key={item} className="bg-green-50 p-4 rounded-xl border border-green-100" data-id="element-82">
                <Check className="w-6 h-6 text-green-600 mx-auto mb-2" data-id="element-83" />
                <p className="font-bold text-sm text-green-900" data-id="element-84">{item}</p>
              </div>)}
          </div>
        </div>
      </section>

      {/* What's Included */}
      <section className="py-14 px-4 bg-gray-50" data-id="element-85">
        <div className="max-w-4xl mx-auto" data-id="element-86">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-10" data-id="element-87">
            ¿Qué incluye el MegaPack Música Lista?
          </h2>
          <div className="space-y-4" data-id="element-88">
            {[{
            num: '1',
            emoji: '📘',
            title: 'TOMO 1 – Fundamentos musicales + actividades listas',
            subtitle: 'El punto de partida para enseñar Música sin improvisar.',
            items: ['Sonido, silencio, ritmo y expresión', 'Actividades listas para aplicar', 'Primer contacto con instrumentos', 'Canciones y repertorio', 'Evaluación sin estrés']
          }, {
            num: '2',
            emoji: '📗',
            title: 'TOMO 2 – Ritmo, percusión y ensamble',
            subtitle: 'Clases dinámicas que se mueven y funcionan.',
            items: ['Percusión corporal e instrumental', 'Ensambles grupales', 'Estrategias para grupos grandes', 'Ritmo sin caos']
          }, {
            num: '3',
            emoji: '📕',
            title: 'TOMO 3 – Lectura musical simple y sin miedo',
            subtitle: 'Cómo enseñar lectura musical sin frustración.',
            items: ['Método progresivo y visual', 'Figuras, símbolos y pentagrama explicados fácil', 'Actividades imprimibles', 'Evaluación clara']
          }, {
            num: '4',
            emoji: '📙',
            title: 'TOMO 4 – Creación musical, composición y proyectos',
            subtitle: 'Para que tus alumnos creen música real.',
            items: ['Exploración sonora', 'Improvisación guiada', 'Composición paso a paso', 'Proyectos interdisciplinarios']
          }, {
            num: '5',
            emoji: '📓',
            title: 'TOMO 5 – Actos escolares y cierre anual',
            subtitle: 'Tu respaldo profesional para todo el año.',
            items: ['Actos escolares sin estrés', 'Proyectos institucionales', 'Muestras musicales', 'Cierre del año con producciones visibles']
          }].map(tomo => <div key={tomo.num} className="bg-white border border-gray-200 rounded-2xl p-6 md:p-8 relative" data-id="element-89">
                <div className="absolute top-4 right-4 w-10 h-10 bg-green-600 text-white rounded-full flex items-center justify-center font-black text-lg" data-id="element-90">
                  {tomo.num}
                </div>
                <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-1.5 pr-12" data-id="element-91">
                  <span className="mr-2" data-id="element-92">{tomo.emoji}</span>
                  {tomo.title}
                </h3>
                <p className="text-gray-500 mb-4 text-sm" data-id="element-93">{tomo.subtitle}</p>
                <ul className="grid grid-cols-1 md:grid-cols-2 gap-2" data-id="element-94">
                  {tomo.items.map((item, idx) => <li key={idx} className="flex items-start gap-2 text-sm text-gray-700" data-id="element-95">
                      <Check className="w-4 h-4 text-green-500 flex-shrink-0 mt-0.5" data-id="element-96" />
                      <span data-id="element-97">{item}</span>
                    </li>)}
                </ul>
              </div>)}
          </div>
        </div>
      </section>

      {/* Material Preview Carousel */}
      <section className="py-14 px-4 bg-white" data-id="element-98">
        <div className="max-w-5xl mx-auto" data-id="element-99">
          <div className="text-center mb-10" data-id="element-100">
            <h3 className="text-3xl md:text-4xl font-bold text-gray-900 mb-2" data-id="element-101">
              👀 MIRÁ POR DENTRO
            </h3>
            <p className="text-gray-500 text-lg" data-id="element-102">
              Así es el material que vas a recibir
            </p>
          </div>
          <div className="relative max-w-3xl mx-auto" ref={carouselRef} data-id="element-103">
            <button onClick={prevSlide} className="absolute left-0 md:-left-12 top-1/2 -translate-y-1/2 z-10 w-10 h-10 bg-white rounded-full shadow-lg flex items-center justify-center hover:bg-gray-50 border border-gray-200" aria-label="Previous slide" data-id="element-104">
              <ChevronLeft className="w-5 h-5" data-id="element-105" />
            </button>
            <button onClick={nextSlide} className="absolute right-0 md:-right-12 top-1/2 -translate-y-1/2 z-10 w-10 h-10 bg-white rounded-full shadow-lg flex items-center justify-center hover:bg-gray-50 border border-gray-200" aria-label="Next slide" data-id="element-106">
              <ChevronRight className="w-5 h-5" data-id="element-107" />
            </button>
            <div className="overflow-hidden rounded-2xl shadow-md" data-id="element-108">
              <div className="flex transition-transform duration-500" style={{
              transform: `translateX(-${currentSlide * 100}%)`
            }} data-id="element-109">
                {materialPreviewImages.map((image, idx) => <div key={idx} className="w-full flex-shrink-0" data-id="element-110">
                    <div className="bg-white border border-gray-100 rounded-2xl overflow-hidden" data-id="element-111">
                      <img src={image.src} alt={image.title} className="w-full" loading="lazy" decoding="async" width="1080" height="1080" data-id="element-112" />
                      <div className="p-4 text-center border-t border-gray-100" data-id="element-113">
                        <p className="font-semibold text-gray-700" data-id="element-114">
                          {image.title}
                        </p>
                      </div>
                    </div>
                  </div>)}
              </div>
            </div>
            <div className="flex justify-center gap-2 mt-5" data-id="element-115">
              {materialPreviewImages.map((_, idx) => <button key={idx} onClick={() => setCurrentSlide(idx)} className={`h-2 rounded-full transition-all ${currentSlide === idx ? 'bg-green-600 w-6' : 'bg-gray-300 w-2'}`} data-id="element-116" />)}
            </div>
          </div>
          <div className="text-center mt-8" data-id="element-117">
            <a href="#checkout" className="inline-block bg-green-600 hover:bg-green-700 text-white font-black px-8 py-3.5 rounded-xl shadow-md hover:shadow-lg transition-all" data-id="element-118">
              🛒 QUIERO ESTE MATERIAL
            </a>
          </div>
        </div>
      </section>

      {/* Benefits */}
      <section className="py-14 px-4 bg-gray-50" data-id="element-119">
        <div className="max-w-6xl mx-auto" data-id="element-120">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-10" data-id="element-121">
            Resultados que transforman
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-122">
            <div className="bg-white p-8 rounded-2xl border border-gray-200" data-id="element-123">
              <h3 className="text-xl font-bold text-gray-900 mb-5" data-id="element-124">
                Qué logran tus estudiantes
              </h3>
              <ul className="space-y-3" data-id="element-125">
                {['Comprender la música desde la práctica', 'Participar más en clase', 'Crear producciones reales', 'Disfrutar las actividades', 'Valorar la música en su vida cotidiana'].map(item => <li key={item} className="flex items-start gap-2.5" data-id="element-126">
                    <Check className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" data-id="element-127" />
                    <span className="text-gray-700" data-id="element-128">{item}</span>
                  </li>)}
              </ul>
            </div>
            <div className="bg-white p-8 rounded-2xl border border-gray-200" data-id="element-129">
              <h3 className="text-xl font-bold text-gray-900 mb-5" data-id="element-130">
                Qué obtenés vos como docente
              </h3>
              <ul className="space-y-3" data-id="element-131">
                {['Ahorrar horas de planificación cada semana', 'Dejar de improvisar', 'Tener todo el año organizado', 'Enseñar con claridad y seguridad', 'Llegar al cierre del ciclo sin estrés', 'Destacarte con propuestas musicales sólidas'].map(item => <li key={item} className="flex items-start gap-2.5" data-id="element-132">
                    <Check className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" data-id="element-133" />
                    <span className="text-gray-700" data-id="element-134">{item}</span>
                  </li>)}
              </ul>
            </div>
          </div>
          <div className="text-center mt-8" data-id="element-135">
            <a href="#checkout" className="inline-block bg-green-600 hover:bg-green-700 text-white font-black px-8 py-3.5 rounded-xl shadow-md hover:shadow-lg transition-all mb-3" data-id="element-136">
              🛒 QUIERO LOGRAR ESTO
            </a>
            <p className="text-sm text-gray-400" data-id="element-137">
              Pago 100% seguro • Descarga inmediata • Acceso de por vida
            </p>
          </div>
        </div>
      </section>

      {/* Bonuses */}
      <section className="py-14 px-4 bg-white" data-id="element-138">
        <div className="max-w-5xl mx-auto" data-id="element-139">
          <div className="text-center mb-10" data-id="element-140">
            <span className="inline-block bg-orange-100 text-orange-700 px-4 py-1.5 rounded-full text-sm font-bold mb-4 uppercase tracking-wide" data-id="element-141">
              🎁 Oferta Especial
            </span>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-3" data-id="element-142">
              BONOS INCLUIDOS HOY — GRATIS
            </h2>
            <p className="text-gray-500" data-id="element-143">
              Al adquirir tu MegaPack, además de los 5 tomos base, recibís
              GRATIS estos 4 bonos exclusivos.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-5" data-id="element-144">
            {[{
            image: 'https://cdn.magicpatterns.com/uploads/qHr8PnRnn46RR9s6nhwEnS/11.png',
            title: 'BONO 1 – Partituras del Mundo',
            desc: 'Repertorio musical multicultural listo para usar en clase.',
            items: ['Partituras de distintas regiones del mundo', 'Canciones tradicionales e internacionales', 'Material ideal para actos y efemérides', 'Propuestas para trabajar diversidad cultural']
          }, {
            image: 'https://cdn.magicpatterns.com/uploads/aWBhVTfSsEBDK6VW5F1K65/12.png',
            title: 'BONO 2 – Música Infantil & Bebés',
            desc: 'Kit especial para nivel inicial y maternal.',
            items: ['Canciones adaptadas para primera infancia', 'Juegos musicales simples y efectivos', 'Recursos visuales y propuestas sensoriales', 'Actividades listas para aplicar sin adaptación']
          }, {
            image: 'https://cdn.magicpatterns.com/uploads/xfjiTjFUdKJDuecrwA9eiN/13.png',
            title: 'BONO 3 – Música + Arte + Teatro',
            desc: 'Proyectos integrados para trabajar de forma interdisciplinaria.',
            items: ['Propuestas Música + Arte', 'Actividades Música + Teatro', 'Ideas para muestras anuales', 'Producciones creativas que se lucen']
          }, {
            image: null,
            title: 'BONO 4 – Pack Música Lista PRO',
            desc: 'Tomos complementarios para profundizar y ampliar.',
            items: ['Ritmo avanzado y secuencias especiales', 'Profundización en lectura musical', 'Proyectos creativos ampliados', 'Recursos extra para actos y muestras']
          }].map((bonus, idx) => <div key={idx} className="bg-white border border-gray-200 rounded-2xl overflow-hidden shadow-sm" data-id="element-145">
                {bonus.image && <div className="flex justify-center p-4 pb-0" data-id="element-146">
                    <div className="relative w-full max-w-[240px] aspect-square" data-id="element-147">
                      <img src={bonus.image} alt={bonus.title} className="w-full h-full object-cover rounded-xl" loading="lazy" decoding="async" width="1080" height="1080" data-id="element-148" />
                      <span className="absolute top-2 right-2 bg-green-500 text-white text-xs font-bold px-2.5 py-1 rounded-full shadow" data-id="element-149">
                        ✨ GRATIS HOY
                      </span>
                    </div>
                  </div>}
                <div className="p-6" data-id="element-150">
                  {!bonus.image && <span className="inline-block bg-green-500 text-white text-xs font-bold px-3 py-1 rounded-full mb-3" data-id="element-151">
                      ✨ GRATIS HOY
                    </span>}
                  <h3 className="text-lg font-bold text-gray-900 mb-1.5" data-id="element-152">
                    {bonus.title}
                  </h3>
                  <p className="text-gray-500 text-sm mb-4" data-id="element-153">{bonus.desc}</p>
                  <ul className="space-y-2" data-id="element-154">
                    {bonus.items.map((item, i) => <li key={i} className="flex items-start gap-2 text-sm text-gray-700" data-id="element-155">
                        <Check className="w-4 h-4 text-green-500 flex-shrink-0 mt-0.5" data-id="element-156" />
                        <span data-id="element-157">{item}</span>
                      </li>)}
                  </ul>
                </div>
              </div>)}
          </div>
        </div>
      </section>

      {/* Pricing / Checkout */}
      <section id="checkout" className="py-16 px-4 bg-gray-50" data-id="element-158">
        <div className="max-w-xl mx-auto" data-id="element-159">
          {/* Scarcity */}
          <div className="flex items-center justify-center gap-2 text-orange-600 font-semibold text-sm mb-5" data-id="element-160">
            <Zap className="w-4 h-4" data-id="element-161" />
            <span data-id="element-162">
              Precio especial activo — no garantizamos que se mantenga
            </span>
          </div>

          <div className="bg-white border-2 border-green-500 rounded-3xl overflow-hidden shadow-2xl" data-id="element-163">
            {/* Green header strip */}
            <div className="bg-green-600 text-white text-center py-3 px-4" data-id="element-164">
              <p className="font-black text-lg tracking-wide" data-id="element-165">
                🔥 OFERTA ESPECIAL POR TIEMPO LIMITADO
              </p>
            </div>

            <div className="p-8 md:p-10" data-id="element-166">
              {/* Stars */}
              <div className="flex items-center justify-center gap-1 mb-4" data-id="element-167">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-yellow-400 text-yellow-400" data-id="element-168" />)}
                <span className="text-sm text-gray-500 ml-2" data-id="element-169">
                  4.9 (1,200+ reseñas)
                </span>
              </div>

              <h3 className="text-2xl md:text-3xl font-black text-gray-900 text-center mb-1" data-id="element-170">
                MEGAPACK MÚSICA LISTA
              </h3>
              <p className="text-gray-500 text-center mb-6" data-id="element-171">
                5 Tomos Base + 4 Bonos PRO
              </p>

              {/* Price block */}
              <div className="text-center mb-2" data-id="element-172">
                <p className="text-gray-400 font-medium text-lg line-through" data-id="element-173">
                  Precio regular $49.99 USD
                </p>
                <div className="flex items-center justify-center gap-3 my-2" data-id="element-174">
                  <span className="text-7xl md:text-8xl font-black text-gray-900 leading-none" data-id="element-175">
                    $9.97
                  </span>
                  <span className="bg-red-100 text-red-600 font-black text-sm px-3 py-1.5 rounded-lg" data-id="element-176">
                    −80%
                  </span>
                </div>
                <p className="text-gray-500 font-medium" data-id="element-177">USD · Pago único</p>
                <p className="text-green-600 font-semibold text-sm mt-1" data-id="element-178">
                  ✓ Pagarás en la moneda de tu país
                </p>
                <p className="text-green-700 font-bold text-base mt-1" data-id="element-179">
                  Ahorrás $40 USD hoy
                </p>
              </div>

              {/* Viewers */}
              <div className="flex items-center justify-center gap-2 text-sm text-orange-500 font-medium my-4" data-id="element-180">
                <Eye className="w-4 h-4" data-id="element-181" />
                <span data-id="element-182">{viewers} personas están viendo esto ahora</span>
              </div>

              {/* Main CTA */}
              <a href="https://docentes.edulabs.online/cart/47462807339257:1" onClick={trackAddToCart} className="block w-full bg-green-600 hover:bg-green-700 active:bg-green-800 text-white font-black text-xl py-5 rounded-2xl text-center mb-3 transition-all shadow-lg hover:shadow-xl" data-id="element-183">
                🛒 SÍ, QUIERO EL MEGAPACK MÚSICA
              </a>

              <p className="text-center text-xs text-gray-400 mb-6" data-id="element-184">
                🔒 Pago 100% seguro · Descarga inmediata · Garantía 7 días
              </p>

              {/* Features Grid */}
              <div className="grid grid-cols-2 gap-3 mb-5" data-id="element-185">
                {[{
                icon: <Check className="w-5 h-5 text-green-600" data-id="element-186" />,
                label: 'Pago único'
              }, {
                icon: <Infinity className="w-5 h-5 text-green-600" data-id="element-187" />,
                label: 'Acceso de por vida'
              }, {
                icon: <Download className="w-5 h-5 text-green-600" data-id="element-188" />,
                label: 'Descarga inmediata'
              }, {
                icon: <Shield className="w-5 h-5 text-green-600" data-id="element-189" />,
                label: 'Garantía 7 días'
              }].map((f, i) => <div key={i} className="flex items-center gap-2.5 bg-green-50 rounded-xl p-3 border border-green-100" data-id="element-190">
                    {f.icon}
                    <p className="text-sm font-semibold text-gray-800" data-id="element-191">
                      {f.label}
                    </p>
                  </div>)}
              </div>

              {/* Bonus Badge */}
              <div className="bg-orange-50 rounded-xl p-4 text-center mb-6 border border-orange-100" data-id="element-192">
                <p className="text-base font-bold text-orange-800" data-id="element-193">
                  🎁 4 Bonos exclusivos incluidos — valor $80 USD
                </p>
              </div>

              {/* Divider */}
              <div className="border-t border-gray-100 my-5" data-id="element-194"></div>

              {/* Payment Methods */}
              <div className="text-center" data-id="element-195">
                <p className="text-gray-400 text-xs font-medium mb-3" data-id="element-196">
                  Métodos de pago aceptados
                </p>
                <div className="flex flex-wrap justify-center items-center gap-4 mb-3 opacity-60 grayscale" data-id="element-197">
                  <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/5/5e/Visa_Inc._logo.svg/2560px-Visa_Inc._logo.svg.png" alt="Visa" className="h-5" loading="lazy" decoding="async" width="128" height="24" data-id="element-198" />
                  <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/2/2a/Mastercard-logo.svg/1280px-Mastercard-logo.svg.png" alt="Mastercard" className="h-5" loading="lazy" decoding="async" width="64" height="24" data-id="element-199" />
                  <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/b/ba/Stripe_Logo%2C_revised_2016.svg/2560px-Stripe_Logo%2C_revised_2016.svg.png" alt="Stripe" className="h-5" loading="lazy" decoding="async" width="96" height="24" data-id="element-200" />
                  <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/f/fa/American_Express_logo_%282018%29.svg/601px-American_Express_logo_%282018%29.svg.png" alt="American Express" className="h-5" loading="lazy" decoding="async" width="72" height="24" data-id="element-201" />
                </div>
                <div className="flex items-center justify-center gap-1.5 text-xs text-gray-400" data-id="element-202">
                  <Lock className="w-3 h-3 text-green-500" data-id="element-203" />
                  <span data-id="element-204">
                    Encriptación SSL 256 bits · Procesamiento seguro certificado
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Guarantee */}
      <section className="py-14 px-4 bg-white" data-id="element-205">
        <div className="max-w-2xl mx-auto" data-id="element-206">
          <div className="flex flex-col md:flex-row items-center gap-6 bg-green-50 border border-green-200 rounded-2xl p-8" data-id="element-207">
            <Shield className="w-16 h-16 text-green-600 flex-shrink-0" data-id="element-208" />
            <div data-id="element-209">
              <h2 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-210">
                Garantía de satisfacción total — 7 días
              </h2>
              <p className="text-gray-600" data-id="element-211">
                Probalo durante 7 días. Si no cumple tus expectativas, te
                devolvemos el 100% de tu dinero. Sin preguntas. Sin
                complicaciones.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="py-14 px-4 bg-gray-50" data-id="element-212">
        <div className="max-w-6xl mx-auto" data-id="element-213">
          <div className="text-center mb-10" data-id="element-214">
            <div className="flex items-center justify-center gap-1 mb-2" data-id="element-215">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-yellow-400 text-yellow-400" data-id="element-216" />)}
            </div>
            <h2 className="text-3xl font-bold text-gray-900" data-id="element-217">
              Lo que dicen otros docentes
            </h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-5" data-id="element-218">
            <TestimonialCard name="María González" role="Profesora de Música" location="Ciudad de México, México" quote="Ahora tengo todo el año organizado." imageInitials="MG" data-id="element-219" />
            <TestimonialCard name="Carlos Rodríguez" role="Docente de Primaria" location="Bogotá, Colombia" quote="Dejé de improvisar las clases." imageInitials="CR" data-id="element-220" />
            <TestimonialCard name="Ana Martínez" role="Maestra de Inicial" location="Lima, Perú" quote="Es el único material que uso." imageInitials="AM" data-id="element-221" />
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="py-14 px-4 bg-white" data-id="element-222">
        <div className="max-w-3xl mx-auto" data-id="element-223">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-10" data-id="element-224">
            Preguntas frecuentes
          </h2>
          <div className="space-y-3" data-id="element-225">
            {[{
            q: '¿En qué formato recibo el material?',
            a: 'Todo el contenido es 100% digital en formato PDF de alta calidad, listo para visualizar en cualquier dispositivo (PC, tablet, celular) o imprimir.'
          }, {
            q: '¿Puedo imprimirlo?',
            a: '¡Sí! El material está diseñado en formato A4 estándar para que puedas imprimir las fichas, actividades y partituras que necesites para tus alumnos.'
          }, {
            q: '¿Qué niveles abarca?',
            a: 'El MegaPack cubre todos los niveles educativos: Maternal, Nivel Inicial (Preescolar), Primaria (1° a 6° grado) y ciclo básico de Secundaria.'
          }, {
            q: '¿Cuándo recibo el acceso?',
            a: 'El acceso es inmediato y automático. Apenas se confirma tu pago, recibís un correo electrónico con el enlace de descarga directa a todo el material.'
          }].map((faq, idx) => <div key={idx} className="bg-gray-50 border border-gray-200 p-5 rounded-xl" data-id="element-226">
                <h3 className="font-bold text-gray-900 mb-1.5" data-id="element-227">{faq.q}</h3>
                <p className="text-gray-500 text-sm" data-id="element-228">{faq.a}</p>
              </div>)}
          </div>
        </div>
      </section>

      {/* Final CTA */}
      <section className="py-16 px-4 bg-green-700 text-white text-center" data-id="element-229">
        <div className="max-w-4xl mx-auto" data-id="element-230">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-231">
            ¿Listo para transformar tu año escolar?
          </h2>
          <p className="text-xl mb-8 opacity-90" data-id="element-232">
            Unite a más de 1,200 docentes que ya organizan su año de Música sin
            estrés.
          </p>
          <a href="#checkout" className="inline-block bg-white text-green-700 font-black text-lg px-10 py-4 rounded-xl hover:bg-green-50 transition-colors shadow-lg" data-id="element-233">
            🛒 QUIERO EMPEZAR AHORA
          </a>
          <p className="mt-5 text-sm opacity-70" data-id="element-234">
            Descarga inmediata · Garantía 7 días · Pago seguro
          </p>
        </div>
      </section>

      {/* Sticky Mobile Buy Bar */}
      <div className="fixed bottom-0 left-0 right-0 z-50 md:hidden bg-white border-t-2 border-green-500 px-4 py-3 shadow-2xl" data-id="element-235"></div>

      {/* Footer */}
      <footer className="bg-gray-900 text-gray-400 py-10 px-4 text-center pb-24 md:pb-10" data-id="element-236">
        <div className="max-w-4xl mx-auto" data-id="element-237">
          <p className="font-bold text-white mb-3" data-id="element-238">MEGAPACK MÚSICA LISTA™</p>
          <p className="text-sm mb-6" data-id="element-239">
            Todos los derechos reservados © {new Date().getFullYear()}
          </p>
          <p className="text-xs text-gray-600" data-id="element-240">
            Este sitio no es parte del sitio web de Facebook o Facebook Inc.
            Además, este sitio no está respaldado por Facebook de ninguna
            manera. FACEBOOK es una marca registrada de FACEBOOK, Inc.
          </p>
        </div>
      </footer>
    </div>;
}